import MaucashModel from './MaucashModel.vue';
export default MaucashModel;
